// utils/exportExcel.js
import * as XLSX from "xlsx";

/**
 * Export any array of objects to Excel
 *
 * @param {Array} rows - Array of objects (each object = row, keys = column headers)
 * @param {string} fileName - File name for the exported Excel
 * @param {string} sheetName - Optional sheet name (default: "Sheet1")
 */
export const exportExcel = (
  rows,
  fileName = "data.xlsx",
  sheetName = "Sheet1"
) => {
  if (!Array.isArray(rows) || rows.length === 0) {
    console.warn("No data provided for Excel export.");
    return;
  }

  // 1. Convert JSON (array of objects) → Sheet
  const worksheet = XLSX.utils.json_to_sheet(rows);

  // 2. Create a new Workbook
  const workbook = XLSX.utils.book_new();

  // 3. Append worksheet to workbook
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

  // 4. Trigger download
  XLSX.writeFile(workbook, fileName);
};
